const adminModelProvider = {
  actions: {
    add: '新增模型',
    delete: '删除',
    edit: '编辑',
    open: '打开 {{name}} 的操作菜单',
    probe: '存活检测',
    probeFailed: '存活检测失败',
    probeSlow: '存活检测已完成，当前延迟偏高',
    probeSuccess: '存活检测已完成',
  },
  columnSelector: {
    label: '选择模型注册列表列',
    trigger: '列',
  },
  deleteDialog: {
    cancel: '取消',
    close: '关闭删除确认',
    confirm: '删除',
    failed: '模型删除失败',
    message: '确认删除模型 {{name}}？删除后，引用该模型的分发密钥和兜底配置将无法继续使用。',
    subtitle: '该操作会调用后端删除接口，已保存的模型连接信息不会保留。',
    success: '模型已删除',
    title: '删除模型？',
  },
  description: '管理模型供应商、接口、模型别名、连接配置、价格和启停状态。',
  drawer: {
    cancel: '取消',
    configFields: {
      anthropic_version: 'Anthropic Version',
      api_key: 'API Key',
      organization: 'Organization',
      project: 'Project',
    },
    configFieldHelp: {
      anthropic_version: 'Anthropic API version header，通常沿用默认值。',
      api_key: '用于调用上游模型供应商 API 的认证密钥，保存后会按敏感字段处理。',
      organization: '可选的 OpenAI Organization header，仅在供应商要求时填写。',
      project: '可选的 OpenAI Project header，仅在供应商要求时填写。',
    },
    createTitle: '新增模型',
    description: '更新模型连接信息、价格和启停状态。',
    detailLoadFailed: '请稍后重试，或检查当前管理员是否仍有模型网关访问权限。',
    detailLoadFailedTitle: '模型详情加载失败',
    editTabs: {
      config: '模型配置',
      fallback: '兜底模型',
      label: '模型编辑页签',
      probe: '模型探测',
      pricing: '模型价格',
    },
    editTitle: '编辑 / {{name}}',
    feedback: {
      createSuccess: '模型创建成功',
      fallbackSaveFailed: '模型已保存，但兜底配置保存失败，请重新检查兜底设置',
      partialSaveFailed: '模型已保存，但部分附属配置保存失败',
      probeSaveFailed: '模型已保存，但探测配置保存失败，请重新检查模型探测设置',
      submitFailed: '保存失败',
      updateSuccess: '模型保存成功',
      validationFailed: '请先修正表单内容',
    },
    fields: {
      baseUrl: 'Base URL',
      enabled: '模型是否启用',
      inputPricePerMillion: '输入价格 / 1M tokens',
      interfaceType: '接口协议',
      modelName: '模型名称',
      outputPricePerMillion: '输出价格 / 1M tokens',
      pricingCurrency: '计价币种',
      provider: '供应商',
      publicModelName: '模型显示名称',
      status: '状态',
    },
    fieldHelp: {
      baseUrl: '上游模型服务的 API 根地址，需以 http:// 或 https:// 开头。',
      enabled: '关闭后该模型不会再作为可调用模型参与路由。',
      interfaceType: '模型网关用于适配请求格式和认证字段的接口协议。',
      modelName: '发送给上游供应商的真实模型 ID，例如 gpt-5-mini。',
      provider: '模型所属供应商，切换后会按供应商默认接口重置接口配置。',
      publicModelName: '展示给用户、应用和分发密钥使用的模型标识，可作为内部统一别名。',
    },
    fallback: {
      activeHint: '当前已切到兜底模型 {{model}}，主模型恢复成功前会持续走兜底。',
      disabledState: '未启用',
      enabled: '启用兜底',
      enabledHelp: '主模型不可用时，可切到另一个同接口的启用模型继续服务。',
      enabledState: '已启用',
      targetHelp: '兜底模型必须启用，并且与当前模型使用相同接口。',
      targetLabel: '兜底模型',
      targetPlaceholder: '请选择兜底模型',
      triggerHelp: '决定兜底由自动探测失败、运行时调用失败，或两者共同触发。',
      triggerLabel: '触发方式',
      triggerModes: {
        probe_only: '仅探测失败时切换',
        probe_or_runtime: '探测失败或运行时失败时切换',
        runtime_only: '仅运行时失败时切换',
      },
    },
    hideSecret: '隐藏密钥',
    placeholders: {
      baseUrl: '例如：https://api.openai.com/v1',
      modelName: '例如：gpt-5-mini',
      publicModelName: '例如：GPT-5 Mini',
      secret: '留空表示沿用已保存密钥',
      secretWithSaved: '已保存：{{value}}，留空沿用',
    },
    probe: {
      disabledState: '未启用',
      enabled: '启用模型探测',
      enabledHelp: '开启后，模型网关会按设定频率主动调用该模型，记录存活状态和延迟。',
      enabledState: '已启用',
      intervalHelp: '正常状态下两次自动探测之间的间隔，范围 5-1440 分钟。',
      intervalLabel: '探测间隔（分钟）',
      mechanismDescription:
        '系统会发送最小化请求验证上游模型是否可用，并记录总耗时、首字符时间和吞吐。失败后进入恢复模式，按更短间隔重试；探测成功后会恢复正常频率，并可配合兜底模型自动回流。',
      mechanismTitle: '探测机制',
      nextProbeAt: '下次计划探测：{{time}}',
      recentTitle: '近期探测信息',
      recoveryIntervalHelp: '失败或恢复模式下的探测间隔，范围 1-1440 分钟。',
      recoveryIntervalLabel: '恢复探测间隔（分钟）',
      warningLatencyHelp: '超过该耗时会标记为延迟高，不等同于失败。',
      warningLatencyLabel: '延迟告警阈值（ms）',
    },
    save: '保存',
    sections: {
      connection: '模型与连接',
      connectionDescription: '模型名称决定上游请求，模型显示名称用于分发和应用选择。',
      credentials: '{{interface}} 配置',
      policy: '价格与状态',
      policyDescription: '价格为可选覆盖值，留空时可使用模型网关全局默认价格。',
      provider: '供应商与接口',
      providerDescription: '接口类型决定后续所需的认证字段和默认 Base URL。',
    },
    showSecret: '显示密钥',
    submitFailed: '保存模型失败，请稍后重试。',
    validation: {
      baseUrlInvalid: 'Base URL 需以 http:// 或 https:// 开头',
      baseUrlRequired: '请输入 Base URL',
      fieldInvalid: '{{field}}格式不正确',
      fieldRequired: '{{field}}不能为空',
      fallbackTargetRequired: '启用兜底后请选择兜底模型',
      interfaceRequired: '请选择接口协议',
      modelNameRequired: '请输入模型名称',
      probeIntervalInvalid: '探测间隔需为 5-1440 之间的整数分钟',
      probeLatencyInvalid: '延迟告警阈值需为 100-120000 之间的整数毫秒',
      probeRecoveryInvalid: '恢复探测间隔需为 1-1440 之间的整数分钟',
      pricingRequired: '价格配置需同时填写币种、输入价格和输出价格',
      providerRequired: '请选择供应商',
      publicModelNameRequired: '请输入模型显示名称',
    },
    wizard: {
      create: '创建模型',
      headerDescription: '第 {{current}} / {{total}} 步',
      next: '下一步',
      previous: '上一步',
      progressLabel: '新增模型进度：第 {{current}} / {{total}} 步，当前为{{step}}',
      provider: {
        defaultDescription: '选择供应商后继续配置接口协议',
        descriptions: {
          anthropic: 'Claude 系列模型。',
          deepseek: 'DeepSeek 系列模型。',
          gemini: 'Gemini 系列模型。',
          glm: 'GLM 系列模型。',
          kimi: 'Kimi 系列模型。',
          minimax: 'MiniMax 系列模型。',
          openai: 'GPT 系列模型。',
          qwen: 'Qwen 系列模型。',
          xai: 'Grok 系列模型。',
        },
      },
      steps: {
        config: {
          title: '模型配置',
        },
        fallback: {
          title: '兜底模型',
        },
        probe: {
          title: '模型探测',
        },
        pricing: {
          title: '价格配置',
        },
        provider: {
          title: '选择供应商',
        },
      },
    },
  },
  empty: '暂无注册模型',
  errorDescription: '请稍后重试，或检查当前管理员是否仍有访问权限。',
  errorDescriptionWithDetail: '后端返回：{{detail}}',
  errorTitle: '模型列表加载失败',
  filters: {
    allProviders: '全部供应商',
    allStatuses: '全部状态',
    providerLabel: '筛选模型供应商',
    searchLabel: '搜索模型',
    searchPlaceholder: '搜索模型、供应商或接口协议',
    statusLabel: '筛选模型状态',
  },
  pagination: {
    next: '下一页',
    pageSize: '{{count}} 条/页',
    previous: '上一页',
  },
  probe: {
    checkedAt: '检查时间',
    detailsLabel: '查看近 24 小时存活探测详情',
    detailsTitle: '近 24 小时探测详情',
    metrics: {
      latency: '总耗时',
      tps: 'TPS',
      ttft: '首字符',
    },
    noData: '未探测',
    statusLabel: '状态',
    status: {
      failed: '失败',
      healthy: '存活',
      slow: '延迟高',
      unknown: '未探测',
    },
  },
  retry: '重试',
  status: {
    active: '启用',
    disabled: '停用',
  },
  table: {
    actions: '操作',
    actualModelName: '模型名称',
    createdAt: '创建时间',
    interface: '接口协议',
    noPricing: '-',
    pricing: '价格',
    probe: '存活探测',
    provider: '模型供应商',
    publicModelName: '模型显示名称',
    status: '状态',
  },
  title: '模型注册',
  workspaceLabel: '模型注册工作区',
}

export default adminModelProvider
